module.exports = __webpack_public_path__ + "img/kitchen-full.ea9e256d.jpg";